var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"ripple",rawName:"v-ripple",value:('var(--normalText15)'),expression:"'var(--normalText15)'"}],staticClass:"btn fRow jCenter aCenter transition-fast",class:{
    flat: _vm.flat,
    fab: _vm.fab,
    mini: _vm.mini,
    invert: _vm.invert,
    ltr: !_vm.rtl,
    wide: _vm.wide,
    disable: _vm.disable,
    fav: _vm.fav},style:({backgroundColor: ("" + _vm.bc)}),attrs:{"title":_vm.label}},[_c('i',{staticClass:"material-icons-round"},[_vm._v(_vm._s(_vm.ic))]),_c('label',[_vm._v(_vm._s(_vm.label))]),(_vm.badge >= 0)?_c('div',{staticClass:"badge"},[_vm._v(_vm._s(_vm.badge))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }